import { cx } from 'cva';

interface Props {
  children: React.ReactNode;
  checkMarkStyle?: 'gray' | 'blue' | 'yellow' | 'purple';
  textColor?: 'light' | 'text-secondary';
}

export function Ul({
  children,
  checkMarkStyle = 'gray',
  textColor = 'text-secondary'
}: Props) {
  return (
    <ul
      className={cx(
        'space-y-2 pl-[1.0625rem] text-[0.8125rem] leading-5',
        {
          'list-image-[url(../public/checkmark-gray.svg)]':
            checkMarkStyle === 'gray',
          'list-image-[url(../public/checkmark-blue.svg)]':
            checkMarkStyle === 'blue',
          'list-image-[url(../public/checkmark-yellow.svg)]':
            checkMarkStyle === 'yellow',
          'list-image-[url(../public/checkmark-purple.svg)]':
            checkMarkStyle === 'purple'
        },
        {
          'text-newGray-200': textColor === 'light',
          'text-secondary': textColor === 'text-secondary'
        }
      )}
    >
      {children}
    </ul>
  );
}
